import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { yupResolver } from '@hookform/resolvers/yup';
import Modal from 'components/Modal/Modal';
import Textarea from 'components/Textarea/Textarea';
import { REASON } from 'constants/formFields';
import { DESCRIPTION_LENGTH } from 'constants/general';
import { deactivationSchema } from 'utils/validators';

import type { TDeactivationSchema } from 'utils/validators';
import type IArchiveModal from '../../interfaces/IArchiveModal';

function ArchiveModal({
  open,
  onReject,
  onSubmit,
  isLoading,
}: IArchiveModal) {
  const { t } = useTranslation();

  const {
    reset,
    handleSubmit,
    control,
  } = useForm<TDeactivationSchema>({
    mode: 'onSubmit',
    resolver: yupResolver(deactivationSchema),
    defaultValues: {
      [REASON]: '',
    },
  });

  const onHandleConfirm = handleSubmit((values) => {
    onSubmit(values.reason);
  });

  useEffect(() => {
    if (open) {
      reset();
    }
  }, [open, reset]);

  return (
    <Modal
      open={open}
      isLoading={isLoading}
      title={t('common.deactivationReason')}
      description={t('common.deactivationReason')}
      onConfirm={onHandleConfirm}
      onReject={onReject}
      closeTitle={t('common.cancel')}
    >
      <Controller
        name={REASON}
        control={control}
        render={({ field: { name, value, onChange }, fieldState: { error } }) => (
          <Textarea
            charactersLimit={DESCRIPTION_LENGTH}
            value={value}
            name={name}
            placeholder={t('common.typeYourMessage')}
            label={t('common.reason')}
            error={error?.message}
            onChange={(e) => onChange(e.target.value.slice(0, DESCRIPTION_LENGTH))}
          />
        )}
      />
    </Modal>
  );
}

export default ArchiveModal;
